import { render, staticRenderFns } from "./StripeForm.vue?vue&type=template&id=3895e556&scoped=true&"
import script from "./StripeForm.vue?vue&type=script&lang=js&"
export * from "./StripeForm.vue?vue&type=script&lang=js&"
import style0 from "./StripeForm.vue?vue&type=style&index=0&id=3895e556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3895e556",
  null
  
)

export default component.exports